import { CSSProperties } from 'react';
import { kebabToCamelCase } from '@/utilities/kebabToCamelCase';

export function cssStringToObject(cssString: string): CSSProperties {
  const result: { [key: string]: string } = {};

  const pairs = cssString.split(';').map(pair => pair.trim()).filter(pair => pair);

  pairs.forEach(pair => {
    const [key, ...valueParts] = pair.split(':');
    if (key && valueParts.length > 0) {
      const camelCaseKey = kebabToCamelCase(key.trim());
      result[camelCaseKey] = valueParts.join(':').trim();
    }
  });

  return result;
}
